import { Link } from 'react-router-dom'
import { DataTable, type DataTableColumn } from '@/components/DataTable'
import { RowActions } from '@/components/RowActions'
import type { Firm } from '@/types/bundle'

export interface FirmRow {
  id: string
  firm: Firm
}

export interface ClientsTableProps {
  rows: FirmRow[]
  onDuplicate: (row: FirmRow) => void
  onDelete: (row: FirmRow) => void
}

export function ClientsTable({ rows, onDuplicate, onDelete }: ClientsTableProps) {
  const columns: DataTableColumn<FirmRow>[] = [
    {
      key: 'name',
      header: 'Name',
      render: (row) => (
        <Link to={`/client-overrides/${row.id}`} className="text-accent hover:underline">
          {row.firm.name}
        </Link>
      ),
    },
    {
      key: 'enabled',
      header: 'Enabled',
      render: (row) => (
        <span className="inline-flex items-center rounded-pill bg-surface-raised px-2 py-1 text-meta text-text-primary">
          {row.firm.enabled ? 'Yes' : 'No'}
        </span>
      ),
    },
    {
      key: 'enabledProducts',
      header: 'Enabled products',
      align: 'right',
      render: (row) => row.firm.enabled_products.length,
    },
    {
      key: 'actions',
      header: '',
      align: 'right',
      render: (row) => <RowActions onDuplicate={() => onDuplicate(row)} onDelete={() => onDelete(row)} />,
    },
  ]

  return <DataTable columns={columns} data={rows} getRowKey={(row) => row.id} />
}
